export default __webpack_public_path__ + "static/media/Architecture.f89a8612.png";